import { createStyles } from "@mantine/core";
import { pxToRem } from "theme";

export const useStyles = createStyles(() => ({
  list: {
    li: {
      listStyle: "disc",
      listStylePosition: "inside",
      marginLeft: pxToRem[12],
    },
    p: {
      display: "inline-block",
    },
  },
}));
